import { fork } from 'redux-saga/effects'
import startup from './startup'
import authentication from './authentication'
import detectMobile from './detectMobile'
import lobby from './lobby';

function* rootSata() {

    yield fork(startup);
    yield fork(detectMobile)
    //except https://mon-ts.truevirtualworld.com:8443
    if (window.location.pathname.split('/')[1] === 'lobbymanager') {
        yield fork(authentication)
    }
    yield fork(lobby)
}

export default rootSata;